// extracted by mini-css-extract-plugin
export default {"root":"Wishlist_root__rnoH8"};